export type DownloadFile = {
  fileName: string;
  base64Data: string;
};

export const startDownload = (files: DownloadFile[]) => {
  const downloadLink = document.createElement('a');

  // 連続でクリックされると無視されるブラウザ(iphoneのsafariで発生)があるためsetTimeoutで遅延させている
  files.forEach((file, idx) => {
    setTimeout(() => {
      // 現状はPDF専用の想定
      // data:application/pdfの場合にiphoneのsafariが反応しないためoctet-streamにしている
      const source = `data:application/octet-stream;base64,${file.base64Data}`;

      downloadLink.href = source;
      downloadLink.download = file.fileName;
      downloadLink.click();
    }, idx * 50);
  });
};
